import PromptInput from "common/widgets/PromptList/PromptInput";
import PasswordFieldDecorator from "common/widgets/PromptList/PasswordFieldDecorator";
export default PromptInput.extend({

    // subclasses use this property to store the element used for the blind entry control
    blindInput: undefined,

    init: function(element, options) {
        PromptInput.fn.init.apply(this, arguments);

        // add .blindBorder class to element's container
        this.element.closest(".singlePromptContainer").addClass("blindBorder");
    },

    destroy: function() {
        if (this.blindWidget) {
            this.blindWidget.unbind("focused", this._focused);
            this.blindWidget.destroy();
            delete this.blindWidget;
        }
        PromptInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Extend the refresh method to update the blind entry element with the blind entry value.
     * NOTE: intentionally overrides refresh, not updateWidgetValue, since we are dealing with a second input widget.
     * We can do this because it calls back to the parent refresh method.
     */
    refresh: function() {
        var blind = this.options.model.get("blindValue");
        this.blindWidget.value(this.formatValue(blind));

        // delegate to the main refresh method
        PromptInput.fn.refresh.call(this);
    },

    /**
     * Override
     * Focus targets are both of the inputs.
     * @return {*}
     */
    _getFocusWidgets: function() {
        return this.blindWidget && this.widget ? [this.blindWidget, this.widget] : [];
    },

    /**
     * Decorate the given field with attributes to make it act right.
     * @param field blind input field
     */
    decorate: function(field) {
        PasswordFieldDecorator.decorate(field);
    },

    _createAndAppendBlindElement: function() {
        // set up a blind element and add to DOM before making widgets
        var id = this.input.attr("id");
        const name = this.input.attr("name");
        this.input.attr({
            id: `${id}_blind`,
            name: `${name}_blind`
        });
        var blindInput = $("<input/>", {
            id,
            name,
            "aria-labelledby": id + "_label"
        });
        blindInput.insertBefore(this.input);
        return blindInput;
    }
});
